// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"5fd68bbb","72":"073f73f7","477":"ee0b50b0","627":"e9ba7803","663":"267ea2e9","667":"b9eb6061","777":"f74ed9f0","803":"35a2ce2e","820":"6d2a43a6"}[chunkId] + ".chunk.js";
};